"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentModel = void 0;
var PaymentModel = /** @class */ (function () {
    function PaymentModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + '/api/v1/crm/payments',
            UPDATE: APPURL + '/api/v1/crm/payments',
            CREATE: APPURL + '/api/v1/crm/payments'
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    PaymentModel.prototype.extract = function (result) {
        return result.data;
    };
    PaymentModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    PaymentModel.prototype.show = function (id) {
        return this.$http.get(this.URLS.FETCH + '/' + id).then(this.cacheResults);
    };
    PaymentModel.prototype.delete = function (data) {
        return this.$http.delete(this.URLS.FETCH + '/' + data.id).then(this.cacheResults);
    };
    ;
    PaymentModel.prototype.voidPayment = function (payment_id) {
        return this.$http.post("".concat(this.URLS.FETCH, "/").concat(payment_id, "/void"), {}).then(this.cacheResults);
    };
    PaymentModel.prototype.refundPayment = function (student_id, payment_id, amount) {
        return this.$http.post("".concat(this.APPURL, "/api/v1/students/").concat(student_id, "/payments/").concat(payment_id, "/refund"), { amount: amount }).then(this.cacheResults);
    };
    return PaymentModel;
}());
exports.PaymentModel = PaymentModel;
PaymentModel.$inject = ['$http', 'APPURL'];
exports.default = PaymentModel;
